var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeftSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1437 12.6863H9.71833L14.273 8.13165C14.637 7.76765 14.637 7.17032 14.273 6.80632C14.0986 6.63155 13.8619 6.53333 13.615 6.53333C13.3681 6.53333 13.1314 6.63155 12.957 6.80632L6.80633 12.957C6.44233 13.321 6.44233 13.909 6.80633 14.273L12.957 20.4237C13.321 20.7877 13.909 20.7877 14.273 20.4237C14.637 20.0597 14.637 19.4717 14.273 19.1077L9.71833 14.553H20.1437C20.657 14.553 21.077 14.133 21.077 13.6197C21.077 13.1063 20.657 12.6863 20.1437 12.6863Z",
    fill: "#ADB8CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftSm);
export default __webpack_public_path__ + "static/media/arrow_left-sm.22369b5a4a7eb18502b9001300385835.svg";
export { ForwardRef as ReactComponent };